
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UPDATE_CONTRACTOR_RATING from "@/apollo/contractors/UpdateContractorRating.gql";
  import CREATE_CONTRACTOR_RATING from "@/apollo/contractors/CreateContractorRating.gql";

  import RatingStars from "@/components/rating/RatingStars.vue";
  import FormTextArea from "@/components/form/FormTextarea.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import ModalContent from "@/components/modal/ModalContent.vue";

  @Component({
    components: {
      ModalContent,
      RatingStars,
      FormTextArea,
      UIButton,
      ModalFullScreen,
      FormGroup,
    }
  })
  export default class ReviewModal extends Vue {
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, default: "" }) readonly review!: string;
    @Prop({ type: Number, default: 0 }) readonly score!: number;
    @Prop({ type: String, default: undefined }) readonly ratingId!: string;
    @Prop({ type: String, default: undefined }) readonly activityId!: string;

    localReview: string = this.review;
    localScore: number = this.score;
    processing: boolean = false;

    get modalTitle(): string {
      return this.ratingId
        ? "Update Review"
        : "Leave Review";
    }

    onSubmit(): Promise<void> {
      if (this.ratingId) {
        return this.handleUpdate();
      }
      return this.handleCreate();
    }

    async handleUpdate(): Promise<void> {
      const isReviewChanged = this.localReview !== this.review;
      const isScoreChanged = this.localScore !== this.score;

      if (!isReviewChanged && !isScoreChanged) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.infoMessage("You have not changed anything in the review")
        );
        return;
      }
      try {
        this.processing = true;

        await this.$apollo.mutate({
          mutation: UPDATE_CONTRACTOR_RATING,
          variables: {
            ratingId: this.ratingId,
            set: {
              review: this.localReview,
              score: this.localScore,
            },
          }
        });
        this.$emit("editted");
        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage("Review was successfully updated.")
        );
      } catch(err) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(err.message)
        );
      } finally {
        this.processing = false;
        this.handleClose();
      }
    }

    async handleCreate(): Promise<void> {
      try {
        this.processing = true;

        await this.$apollo.mutate({
          mutation: CREATE_CONTRACTOR_RATING,
          variables: {
            object: {
              contractor_id: this.contractorId,
              reviewer_id: this.currentUserId,
              review: this.localReview,
              score: this.localScore,
              activity_id: this.activityId || null,
              deleted: false,
            },
          },
        });
        this.$emit("reviewCreated");
        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage("Review was successfully submitted.")
        );
      } catch(err) {
          this.$eventBus.emit(
            NOTIFICATION,
            Message.errorMessage(err.message)
          );
      } finally {
          this.processing = false;
          this.handleClose();
      }
    }

    handleClose(): void {
      this.localReview = "";
      this.localScore = 0;
      this.$emit("close");
    }
  }
